var cartNoteTyping;

validateQty = function (qty) {
  if (parseFloat(qty) == parseInt(qty) && !isNaN(qty)) {
    // We have a valid number!
  } else {
    // Not a number. Default to 1.
    qty = 1;
  }
  return qty;
};

const countryList = {
  AF: "Afghanistan",
  AX: "Aland Islands",
  AL: "Albania",
  DZ: "Algeria",
  AS: "American Samoa",
  AD: "Andorra",
  AO: "Angola",
  AI: "Anguilla",
  AQ: "Antarctica",
  AG: "Antigua and Barbuda",
  AR: "Argentina",
  AM: "Armenia",
  AW: "Aruba",
  AU: "Australia",
  AT: "Austria",
  AZ: "Azerbaijan",
  BS: "Bahamas",
  BH: "Bahrain",
  BD: "Bangladesh",
  BB: "Barbados",
  BY: "Belarus",
  BE: "Belgium",
  BZ: "Belize",
  BJ: "Benin",
  BM: "Bermuda",
  BT: "Bhutan",
  BO: "Bolivia",
  BQ: "Bonaire, Sint Eustatius and Saba",
  BA: "Bosnia and Herzegovina",
  BW: "Botswana",
  BV: "Bouvet Island",
  BR: "Brazil",
  IO: "British Indian Ocean Territory",
  BN: "Brunei Darussalam",
  BG: "Bulgaria",
  BF: "Burkina Faso",
  BI: "Burundi",
  KH: "Cambodia",
  CM: "Cameroon",
  CA: "Canada",
  CV: "Cape Verde",
  KY: "Cayman Islands",
  CF: "Central African Republic",
  TD: "Chad",
  CL: "Chile",
  CN: "China",
  CX: "Christmas Island",
  CC: "Cocos (Keeling) Islands",
  CO: "Colombia",
  KM: "Comoros",
  CG: "Congo",
  CD: "Congo, the Democratic Republic of the",
  CK: "Cook Islands",
  CR: "Costa Rica",
  CI: "Cote D'Ivoire",
  HR: "Croatia",
  CU: "Cuba",
  CW: "Curacao",
  CY: "Cyprus",
  CZ: "Czech Republic",
  DK: "Denmark",
  DJ: "Djibouti",
  DM: "Dominica",
  DO: "Dominican Republic",
  EC: "Ecuador",
  EG: "Egypt",
  SV: "El Salvador",
  GQ: "Equatorial Guinea",
  ER: "Eritrea",
  EE: "Estonia",
  ET: "Ethiopia",
  FK: "Falkland Islands (Malvinas)",
  FO: "Faroe Islands",
  FJ: "Fiji",
  FI: "Finland",
  FR: "France",
  GF: "French Guiana",
  PF: "French Polynesia",
  TF: "French Southern Territories",
  GA: "Gabon",
  GM: "Gambia",
  GE: "Georgia",
  DE: "Germany",
  GH: "Ghana",
  GI: "Gibraltar",
  GR: "Greece",
  GL: "Greenland",
  GD: "Grenada",
  GP: "Guadeloupe",
  GU: "Guam",
  GT: "Guatemala",
  GG: "Guernsey",
  GN: "Guinea",
  GW: "Guinea-Bissau",
  GY: "Guyana",
  HT: "Haiti",
  HM: "Heard Island and Mcdonald Islands",
  VA: "Holy See (Vatican City State)",
  HN: "Honduras",
  HK: "Hong Kong",
  HU: "Hungary",
  IS: "Iceland",
  IN: "India",
  ID: "Indonesia",
  IR: "Iran, Islamic Republic of",
  IQ: "Iraq",
  IE: "Ireland",
  IM: "Isle of Man",
  IL: "Israel",
  IT: "Italy",
  JM: "Jamaica",
  JP: "Japan",
  JE: "Jersey",
  JO: "Jordan",
  KZ: "Kazakhstan",
  KE: "Kenya",
  KI: "Kiribati",
  KP: "Korea, Democratic People's Republic of",
  KR: "Korea, Republic of",
  XK: "Kosovo",
  KW: "Kuwait",
  KG: "Kyrgyzstan",
  LA: "Lao People's Democratic Republic",
  LV: "Latvia",
  LB: "Lebanon",
  LS: "Lesotho",
  LR: "Liberia",
  LY: "Libyan Arab Jamahiriya",
  LI: "Liechtenstein",
  LT: "Lithuania",
  LU: "Luxembourg",
  MO: "Macao",
  MK: "Macedonia, the Former Yugoslav Republic of",
  MG: "Madagascar",
  MW: "Malawi",
  MY: "Malaysia",
  MV: "Maldives",
  ML: "Mali",
  MT: "Malta",
  MH: "Marshall Islands",
  MQ: "Martinique",
  MR: "Mauritania",
  MU: "Mauritius",
  YT: "Mayotte",
  MX: "Mexico",
  FM: "Micronesia, Federated States of",
  MD: "Moldova, Republic of",
  MC: "Monaco",
  MN: "Mongolia",
  ME: "Montenegro",
  MS: "Montserrat",
  MA: "Morocco",
  MZ: "Mozambique",
  MM: "Myanmar",
  NA: "Namibia",
  NR: "Nauru",
  NP: "Nepal",
  NL: "Netherlands",
  AN: "Netherlands Antilles",
  NC: "New Caledonia",
  NZ: "New Zealand",
  NI: "Nicaragua",
  NE: "Niger",
  NG: "Nigeria",
  NU: "Niue",
  NF: "Norfolk Island",
  MP: "Northern Mariana Islands",
  NO: "Norway",
  OM: "Oman",
  PK: "Pakistan",
  PW: "Palau",
  PS: "Palestinian Territory, Occupied",
  PA: "Panama",
  PG: "Papua New Guinea",
  PY: "Paraguay",
  PE: "Peru",
  PH: "Philippines",
  PN: "Pitcairn",
  PL: "Poland",
  PT: "Portugal",
  PR: "Puerto Rico",
  QA: "Qatar",
  RE: "Reunion",
  RO: "Romania",
  RU: "Russian Federation",
  RW: "Rwanda",
  BL: "Saint Barthelemy",
  SH: "Saint Helena",
  KN: "Saint Kitts and Nevis",
  LC: "Saint Lucia",
  MF: "Saint Martin",
  PM: "Saint Pierre and Miquelon",
  VC: "Saint Vincent and the Grenadines",
  WS: "Samoa",
  SM: "San Marino",
  ST: "Sao Tome and Principe",
  SA: "Saudi Arabia",
  SN: "Senegal",
  RS: "Serbia",
  CS: "Serbia and Montenegro",
  SC: "Seychelles",
  SL: "Sierra Leone",
  SG: "Singapore",
  SX: "Sint Maarten",
  SK: "Slovakia",
  SI: "Slovenia",
  SB: "Solomon Islands",
  SO: "Somalia",
  ZA: "South Africa",
  GS: "South Georgia and the South Sandwich Islands",
  SS: "South Sudan",
  ES: "Spain",
  LK: "Sri Lanka",
  SD: "Sudan",
  SR: "Suriname",
  SJ: "Svalbard and Jan Mayen",
  SZ: "Swaziland",
  SE: "Sweden",
  CH: "Switzerland",
  SY: "Syrian Arab Republic",
  TW: "Taiwan, Province of China",
  TJ: "Tajikistan",
  TZ: "Tanzania, United Republic of",
  TH: "Thailand",
  TL: "Timor-Leste",
  TG: "Togo",
  TK: "Tokelau",
  TO: "Tonga",
  TT: "Trinidad and Tobago",
  TN: "Tunisia",
  TR: "Turkey",
  TM: "Turkmenistan",
  TC: "Turks and Caicos Islands",
  TV: "Tuvalu",
  UG: "Uganda",
  UA: "Ukraine",
  AE: "United Arab Emirates",
  GB: "United Kingdom",
  US: "United States",
  UM: "United States Minor Outlying Islands",
  UY: "Uruguay",
  UZ: "Uzbekistan",
  VU: "Vanuatu",
  VE: "Venezuela",
  VN: "Viet Nam",
  VG: "Virgin Islands, British",
  VI: "Virgin Islands, U.s.",
  WF: "Wallis and Futuna",
  EH: "Western Sahara",
  YE: "Yemen",
  ZM: "Zambia",
  ZW: "Zimbabwe",
};

let convertShippingAmount = freeShippingBarAmount;
function checkShippingAvailablity() {
  let selectedCountry = Shopify.country;
  let shippingCountriesContainer = $("#shippingcountries");
  if (shippingCountriesContainer.length == 0) {
    shippingCountriesContainer = $("#shippingCountry");
  }
  if (
    shippingCountriesContainer &&
    shippingCountriesContainer.find("option").length > 0
  ) {
    let shippingSelectedCountry = countryList[selectedCountry];
    if (
      shippingCountriesContainer.find(
        'option[value="' + shippingSelectedCountry + '"]'
      ).length > 0
    ) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
}

/* ── Free-gift processing lock ────────────────────────────── */
let freeGiftProcessing = false;
let freeGiftLockTime = 0;

function freeShippingBar(cart) {
  let countryAvailable = checkShippingAvailablity();
  let shippingBarContainer = $("[data-free-shipping-container]");

  if (countryAvailable && shippingBarContainer.length > 0) {
    if (cart.item_count == 0) {
      shippingBarContainer.addClass("hidden");
      updateGwpAttribute("empty_cart");
      return false;
    }

    let excludedItem = "gift card";
    let isOnlyGiftCards = true;
    let cartPrice = 0;
    let freeGiftInCart = false;
    let freeGiftLineIndex = null;
    let freeGiftQty = 0;

    cart.items.forEach(function (item, index) {
      if (item.handle === freeGiftHandle) {
        freeGiftInCart = true;
        freeGiftQty += item.quantity;
        freeGiftLineIndex = index + 1;
        return;
      }
      if (!item.title.toLowerCase().includes(excludedItem.toLowerCase())) {
        isOnlyGiftCards = false;
      }
      // Exclude BXGY bonus from shipping calculation ($0 product)
      if (bxgyEnabled && item.handle === bxgyBonusHandle) {
        return;
      }
      cartPrice += item.line_price;
    });

    if (isOnlyGiftCards) {
      cartPrice = 0;
    }

    let freeShippingThreshold = convertShippingAmount;
    let freeGiftThreshold = freeGiftThresholdAmount;

    let hasShipping = cartPrice >= freeShippingThreshold;
    let hasGift = cartPrice >= freeGiftThreshold;

    let percentage;
    if (!freeGiftEnabled) {
      percentage = (cartPrice / freeShippingThreshold) * 100;
      if (percentage > 100) percentage = 100;
    } else if (hasGift) {
      percentage = 100;
    } else if (hasShipping) {
      let giftProgress = (cartPrice - freeShippingThreshold) / (freeGiftThreshold - freeShippingThreshold);
      percentage = 50 + (giftProgress * 50);
    } else {
      percentage = (cartPrice / freeShippingThreshold) * 50;
    }
    if (percentage > 100) percentage = 100;

    let $text = $("[data-free-shipping-text]");
    let $bar = $("[data-free-shipping-bar]");

    if (freeGiftEnabled && hasGift) {
      $text.html("Congratulations! You have free shipping and a <strong>free gift!</strong>");
      $bar.addClass("free-shipping");
    } else if (freeGiftEnabled && hasShipping) {
      let remaining = Shopify.formatMoney(freeGiftThreshold - cartPrice, moneyFormat);
      $text.html("You've got free shipping! You are <strong>" + remaining + "</strong> away from a free gift.");
      $bar.removeClass("free-shipping");
    } else if (hasShipping) {
      $text.text("Congratulations! You got free shipping.");
      $bar.addClass("free-shipping");
    } else {
      let remaining = Shopify.formatMoney(freeShippingThreshold - cartPrice, moneyFormat);
      $text.html("You are <strong>" + remaining + "</strong> away from free shipping.");
      $bar.removeClass("free-shipping");
    }

    $bar.css("width", percentage + "%");
    shippingBarContainer.removeClass("hidden");

    if (!freeGiftEnabled) return;

    // Safety timeout: release stuck lock after 10 seconds
    if (freeGiftProcessing && (Date.now() - freeGiftLockTime > 10000)) {
      console.warn("GWP: lock was stuck for 10s — releasing");
      freeGiftProcessing = false;
    }

    if (freeGiftProcessing) return;

    // Fix duplicate: if gift is in cart with qty > 1, reduce to 1
    if (freeGiftInCart && freeGiftQty > 1) {
      freeGiftProcessing = true;
      freeGiftLockTime = Date.now();
      $.ajax({
        type: "POST",
        url: cartChangeUrl,
        data: { line: freeGiftLineIndex, quantity: 1 },
        dataType: "json",
        success: function () {
          jQuery.getJSON(cartUrl, function (updatedCart) {
            freeGiftProcessing = false;
            buildCart(updatedCart, false);
          });
        },
        error: function () { freeGiftProcessing = false; }
      });
      return;
    }

    let declined = sessionStorage.getItem("freeGiftDeclined") === "true";

    if (hasGift && !freeGiftInCart && !declined) {
      freeGiftProcessing = true;
      freeGiftLockTime = Date.now();
      jQuery.getJSON(cartUrl, function (freshCart) {
        var giftAlreadyInCart = false;
        var freshPrice = 0;
        var freshOnlyGiftCards = true;
        freshCart.items.forEach(function (item) {
          if (item.handle === freeGiftHandle) { giftAlreadyInCart = true; return; }
          if (!item.title.toLowerCase().includes("gift card")) freshOnlyGiftCards = false;
          freshPrice += item.line_price;
        });
        if (freshOnlyGiftCards) freshPrice = 0;

        if (giftAlreadyInCart || freshPrice < freeGiftThreshold) {
          freeGiftProcessing = false;
          return;
        }

        getGiftVariantId(function (variantId) {
          if (!variantId) { freeGiftProcessing = false; return; }
          $.ajax({
            type: "POST",
            url: cartAddUrl,
            data: { id: variantId, quantity: 1 },
            dataType: "json",
            success: function () {
              jQuery.getJSON(cartUrl, function (updatedCart) {
                freeGiftProcessing = false;
                updateGwpAttribute("added");
                buildCart(updatedCart, false);
              });
            },
            error: function () {
              freeGiftProcessing = false;
              updateGwpAttribute("add_failed");
            }
          });
        });
      }).fail(function () { freeGiftProcessing = false; });

    } else if (!hasGift && freeGiftInCart) {
      freeGiftProcessing = true;
      freeGiftLockTime = Date.now();
      sessionStorage.removeItem("freeGiftDeclined");
      $.ajax({
        type: "POST",
        url: cartChangeUrl,
        data: { line: freeGiftLineIndex, quantity: 0 },
        dataType: "json",
        success: function () {
          jQuery.getJSON(cartUrl, function (updatedCart) {
            freeGiftProcessing = false;
            updateGwpAttribute("removed_threshold");
            if (window.location.pathname.indexOf("/cart") > -1) {
              cartPageUpdate(updatedCart);
            } else {
              buildCart(updatedCart, false);
            }
          });
        },
        error: function () {
          freeGiftProcessing = false;
          updateGwpAttribute("remove_failed");
        }
      });

    } else if (hasGift && freeGiftInCart) {
      updateGwpAttribute("added");
    } else if (!hasGift) {
      sessionStorage.removeItem("freeGiftDeclined");
      updateGwpAttribute("not_qualified");
    }
  }
}

/* ── Fetch gift variant ID (cached) ── */
function getGiftVariantId(callback) {
  if (freeGiftVariantId) {
    callback(freeGiftVariantId);
    return;
  }
  $.getJSON("/products/" + freeGiftHandle + ".js", function (product) {
    if (product && product.variants && product.variants.length > 0) {
      freeGiftVariantId = product.variants[0].id;
      callback(freeGiftVariantId);
    } else {
      callback(null);
    }
  }).fail(function () { callback(null); });
}

/* ── GWP cart attribute stamping ── */
var gwpLastStatus = "";
function updateGwpAttribute(status) {
  if (!freeGiftEnabled || status === gwpLastStatus) return;
  gwpLastStatus = status;
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: JSON.stringify({
      attributes: {
        gwp_status: status,
        gwp_updated: new Date().toISOString()
      }
    }),
    contentType: "application/json",
    dataType: "json"
  });
}

/* ── BXGY (Buy X Get Y) ── */

let bxgyProcessing = false;
let bxgyLockTime = 0;

function bxgyCheck(cart) {
  if (!bxgyEnabled) return;
  if (cart.item_count === 0) {
    sessionStorage.removeItem("bxgyDeclined");
    return;
  }

  let triggerInCart = false;
  let bonusInCart = false;
  let bonusLineIndex = null;
  let bonusQty = 0;

  cart.items.forEach(function (item, index) {
    if (item.handle === bxgyTriggerHandle) triggerInCart = true;
    if (item.handle === bxgyBonusHandle) {
      bonusInCart = true;
      bonusQty += item.quantity;
      bonusLineIndex = index + 1;
    }
  });

  if (bxgyProcessing && (Date.now() - bxgyLockTime > 10000)) {
    console.warn("BXGY: lock was stuck for 10s — releasing");
    bxgyProcessing = false;
  }
  if (bxgyProcessing) return;

  if (bonusInCart && bonusQty > 1) {
    bxgyProcessing = true;
    bxgyLockTime = Date.now();
    $.ajax({
      type: "POST", url: cartChangeUrl,
      data: { line: bonusLineIndex, quantity: 1 },
      dataType: "json",
      success: function () {
        jQuery.getJSON(cartUrl, function (updatedCart) {
          bxgyProcessing = false;
          buildCart(updatedCart, false);
        });
      },
      error: function () { bxgyProcessing = false; }
    });
    return;
  }

  let declined = sessionStorage.getItem("bxgyDeclined") === "true";

  if (triggerInCart && !bonusInCart && !declined) {
    // Add the bonus product
    bxgyProcessing = true;
    bxgyLockTime = Date.now();
    if (!bxgyBonusVariantId) { bxgyProcessing = false; return; }
    $.ajax({
      type: "POST",
      url: cartAddUrl,
      data: { id: bxgyBonusVariantId, quantity: 1 },
      dataType: "json",
      success: function () {
        jQuery.getJSON(cartUrl, function (updatedCart) {
          bxgyProcessing = false;
          updateBxgyAttribute("added");
          buildCart(updatedCart, false);
        });
      },
      error: function () {
        bxgyProcessing = false;
        updateBxgyAttribute("add_failed");
      }
    });
  } else if (!triggerInCart && bonusInCart) {
    bxgyProcessing = true;
    bxgyLockTime = Date.now();
    sessionStorage.removeItem("bxgyDeclined");
    $.ajax({
      type: "POST", url: cartChangeUrl,
      data: { line: bonusLineIndex, quantity: 0 },
      dataType: "json",
      success: function () {
        jQuery.getJSON(cartUrl, function (updatedCart) {
          bxgyProcessing = false;
          updateBxgyAttribute("removed_no_trigger");
          if (window.location.pathname.indexOf("/cart") > -1) {
            cartPageUpdate(updatedCart);
          } else {
            buildCart(updatedCart, false);
          }
        });
      },
      error: function () {
        bxgyProcessing = false;
        updateBxgyAttribute("remove_failed");
      }
    });
  } else if (triggerInCart && bonusInCart) {
    updateBxgyAttribute("added");
  } else if (!triggerInCart) {
    sessionStorage.removeItem("bxgyDeclined");
  }
}

/* ── BXGY cart attribute stamping ── */
var bxgyLastStatus = "";
function updateBxgyAttribute(status) {
  if (!bxgyEnabled || status === bxgyLastStatus) return;
  bxgyLastStatus = status;
  $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: JSON.stringify({
      attributes: {
        bxgy_status: status,
        bxgy_updated: new Date().toISOString()
      }
    }),
    contentType: "application/json",
    dataType: "json"
  });
}

var favicon = false;

function browserTabNotification() {
  if (browserNotificationStatus) {
    favicon = new Favico({
      animation: "pop",
      bgColor: browserNotificationBg,
      textColor: browserNotificationText,
      type: browserNotificationShape,
    });
  }
}

$(document).ready(function () {
  browserTabNotification();
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  if (freeShippingBarStatus) {
    if (Shopify.currency.active != shopCurrency) {
      let shippingAmount = parseInt(freeShippingBarAmount);
      if (shippingAmount != undefined) {
        convertShippingAmount = parseFloat(
          (shippingAmount * Shopify.currency.rate).toFixed(2)
        );
      }
    }
  }
});

$(document).on("keydown", "[name=note]", function (e) {
  clearTimeout(cartNoteTyping);
});

$(document).on("keyup ", "[name=note]", function (evt) {
  var _this = $(this);
  clearTimeout(cartNoteTyping);
  cartNoteTyping = setTimeout(function () {
    var currentVal = _this.val();
    $.ajax({
      url: cartUpdateUrl,
      type: "POST",
      data: { note: currentVal },
      dataType: "json",
      success: function (result) {},
    });
  }, 750);
});

if (window.location.pathname.indexOf("/cart") > -1) {
  // Shipping Estimations

  (function () {
    function shippingEstimates() {
      if (Shopify && Shopify.CountryProvinceSelector) {
        var country = document.getElementById("shippingCountry");
        if (!country) {
          return false;
        }
        var shipping = new Shopify.CountryProvinceSelector(
          "shippingCountry",
          "shippingProvince",
          {
            hideElement: "shippingProvinceContainer",
          }
        );

        setupEventListeners();
      }
    }

    function setupEventListeners() {
      var button = document.getElementById("getShippingEstimates");
      if (button) {
        button.addEventListener("click", (e) => {
          e.preventDefault();
          $("#ShippingWrapperResponse")
            .html("")
            .removeClass("success")
            .removeClass("error")
            .hide();
          var shippingAddress = {};
          shippingAddress.zip = jQuery("#shippingZip").val() || "";
          shippingAddress.country = jQuery("#shippingCountry").val() || "";
          shippingAddress.province = jQuery("#shippingProvince").val() || "";
          _getCartShippingRates(shippingAddress);
        });
      }
    }

    var _getCartShippingRates = function (shippingAddress) {
      var params = {
        type: "POST",
        url: "/cart/shipping_rates.json",
        data: jQuery.param({ shipping_address: shippingAddress }),
        success: function (data) {
          _render(data.shipping_rates);
        },
        error: _onError,
      };
      jQuery.ajax(params);
    };

    var _fullMessagesFromErrors = function (errors) {
      var fullMessages = [];
      jQuery.each(errors, function (attribute, messages) {
        jQuery.each(messages, function (index, message) {
          fullMessages.push(message);
        });
      });
      return fullMessages;
    };
    var _onError = function (XMLHttpRequest, textStatus) {
      var data = eval("(" + XMLHttpRequest.responseText + ")");
      feedback = _fullMessagesFromErrors(data).join(", ") + ".";
      $("#ShippingWrapperResponse")
        .html('<p class="error-text">' + feedback + "</p>")
        .addClass("error")
        .show();
    };
    var _render = function (response) {
      if (response && response.length > 0) {
        var html = '<p class="success-text">';
        response.forEach(function (shipping) {
          html += `<span><strong>${
            shipping.name
          }:</strong>${Shopify.formatMoney(
            shipping.price * 100,
            moneyFormat
          )}</span>`;
        });
        html += "</p>";
        $("#ShippingWrapperResponse").html(html).addClass("success").show();
      } else {
        $("#ShippingWrapperResponse")
          .html('<p class="error-text">' + notAvailableLabel + "</p>")
          .addClass("error")
          .show();
      }
    };
    setTimeout(function () {
      shippingEstimates();
      $.ajax({
        url: mainCartUrl,
        type: "GET",
        dataType: "json",
        success: function (result) {
          if (result.item_count > 0) {
            freeShippingBar(result);
            bxgyCheck(result);
            upsellCartProducts(result);
          }
        },
      });
    }, 500);

    window.shippingEstimates = shippingEstimates;
  })();

  // Update quantity based on input on change

  changeCartItem = function (line, quantity) {
    var params = {
      type: "POST",
      url: cartChangeUrl,
      data: "quantity=" + quantity + "&line=" + line,
      dataType: "json",
      success: function (cart) {
        // if (quantity == 0) {
        //     $('[name="updates[]"][data-line="' + line + '"]').closest('tr').remove();
        // }
        if (cart.item_count == 0) {
          emptyCartStatus = true;
          // $('[data-cart-form]').hide();
          // $('[data-cart-empty]').show();
          $("[data-cart-count]").hide();
        } else {
          emptyCartStatus = false;
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          $("[data-cart-count]").show();

          var item = cart.items[line - 1];
          if (item) {
            $('[name="updates[]"][data-line="' + line + '"]').val(
              item.quantity
            );
          }
        }
        cartPageUpdate(cart);
      },
      error: function (XMLHttpRequest, textStatus) {
        let errorContainer = document.querySelector(".cart-item-error");
          console.log(errorContainer,XMLHttpRequest.responseJSON.description);
          console.log('hello',XMLHttpRequest.responseJSON.description);
				  errorContainer.innerHTML = XMLHttpRequest.responseJSON.description;
        jQuery.getJSON(cartUrl, function (cart, textStatus) {
          if (quantity == 0) {
            $('[name="updates[]"][data-line="' + line + '"]')
              .closest("tr")
              .remove();
          }
          cartItemsCount = cart.item_count;
          if (favicon) {
            favicon.badge(cartItemsCount);
          }
          if (cart.item_count == 0) {
            // $('[data-cart-form]').hide();
            // $('[data-cart-empty]').show();
            $("[data-cart-count]").hide();
          } else {
            $("[data-cart-count]").show();

            var item = cart.items[line - 1];
            if (item) {
              $('[name="updates[]"][data-line="' + line + '"]').val(
                item.quantity
              );
            }
          }
          cartPageUpdate(cart);
        });
      },
    };
    jQuery.ajax(params);
  };

  $(document).on("click", ".line_item_change", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      $qtySelector = $el.siblings('input[name="updates[]"]');

    $("#cartItemError-" + line).html("");
    var qty = parseInt($qtySelector.val().replace(/\D/g, ""));

    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");
    var qty = validateQty(qty);

    if ($el.hasClass("quantity-up")) {
      qty += 1;
    } else {
      qty -= 1;
      if (qty <= 0) qty = 0;
    }
    $qtySelector.val(qty);
    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("change", '[name="updates[]"]', function (evt) {
    evt.preventDefault();
    var $el = $(this),
      line = $el.data("line"),
      parent = $el.closest("tr"),
      qty = parseInt($el.val().replace(/\D/g, ""));
    parent.addClass("disabled");
    parent.closest("[data-cart-items]").addClass("disabled");

    $("#cartItemError-" + line).html("");
    qty = validateQty(qty);
    // Add or subtract from the current quantity

    if (line) {
      changeCartItem(line, qty);
    }
  });

  $(document).on("click", ".line_item_remove", function (evt) {
    evt.preventDefault();
    var $el = $(this),
      parent = $el.closest("tr"),
      line = $el.data("line");
    // Track if customer manually removes the free gift
    if (freeGiftEnabled && parent.attr("data-gift-handle") === freeGiftHandle) {
      sessionStorage.setItem("freeGiftDeclined", "true");
      updateGwpAttribute("removed_by_customer");
    }
    // Track if customer manually removes the BXGY bonus
    if (bxgyEnabled && parent.attr("data-bxgy-handle") === bxgyBonusHandle) {
      sessionStorage.setItem("bxgyDeclined", "true");
      updateBxgyAttribute("removed_by_customer");
    }
    // If it has a data-line, update the cart
    if (line) {
      parent.addClass("disabled");
      parent.closest("[data-cart-items]").addClass("disabled");
      changeCartItem(line, 0);
    }
  });
} else {
  // POST to cart/change.js returns the cart in JSON
  changeItem = function (line, quantity, callback) {
    var $body = $(document.body),
      params = {
        type: "POST",
        url: cartChangeUrl,
        data: "quantity=" + quantity + "&line=" + line,
        dataType: "json",
        success: function (cart) {
          if (cart.item_count == 0) {
            emptyCartStatus = true;
            $("[data-cart-count]").hide();
          } else {
            emptyCartStatus = false;
            $("[data-cart-count]").show();
          }
          var item = cart.items[line - 1];
          if (item) {
            $(
              '.ajaxcart__qty-num[name="updates[]"][data-line="' + line + '"]'
            ).val(item.quantity);
          }
          callback(cart);
        },
        error: function (XMLHttpRequest, textStatus) {

          let errorContainer = document.querySelector(".cart-item-error");
          console.log(errorContainer,XMLHttpRequest.responseJSON.description);
          console.log('hello',XMLHttpRequest.responseJSON.description);
				  errorContainer.innerHTML = XMLHttpRequest.responseJSON.description;
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            callback(cart);
          });
        },
      };
    jQuery.ajax(params);
  };

  updateQuantity = function (line, qty, callback) {
    isUpdating = true;
    setTimeout(function () {
      changeItem(line, qty, callback);
    }, 250);
  };

  function getvaluefromdataattribute(name) {
    return $('input[data-attr="' + name + '"]').val();
  }

  $("#Recipient-Checkbox").click(function () {
    if (!this.checked) {
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
    }
  });

  if (cartDrawerEnable) {
    // POST to cart/add.js returns the cart in JSON
    $("body").on("click", ".Sd_addProduct", function (evt) {
      evt.preventDefault();

      let submit = $(this);
      let form = $(this).closest("form");
      if (submit.hasClass("Sd_addProductSticky")) {
        form = jQuery("#" + submit.attr("form"));
      }
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        focusElement = submit;
      }
      let parentSection = form.closest(".shopify-section");
      var Email = $('input[data-attr="' + "email" + '"]').val();
      $('input[data-attr="' + "email" + '"]').val("");
      $('input[data-attr="' + "name" + '"]').val("");
      parentSection.find(".productErrors").hide().html("");
      submit.addClass("is-loading");
      if (form.closest(".yv_side_drawer_wrapper").length == 0) {
        $("[data-drawer-body]").html(preLoadLoadGif);
        $("body")
          .find("[data-side-drawer]")
          .attr("class", "yv_side_drawer_wrapper");
        $("body").find("[data-drawer-title]").html(cartTitleLabel);
        $("body").find("[data-side-drawer]").attr("id", "mini__cart");
        $("body").find("[data-side-drawer]").addClass("mini_cart");
      }
      params = {
        type: "POST",
        url: cartAddUrl,
        data: form.serialize(),
        dataType: "json",
        success: function (line_item) {
          if (form.closest(".quick-add-popup").length > 0) {
            form.closest(".quick-add-popup")[0].classList.remove("show");
            form.closest("[quick-add-body]")[0].innerHTML = "";
            document.body.classList.remove("quick-add-popup-open");
          }
          if (form.closest(".yv_side_drawer_wrapper").length > 0) {
            $("[data-drawer-body]").html(preLoadLoadGif);
            $("body")
              .find("[data-side-drawer]")
              .attr("class", "yv_side_drawer_wrapper");
            $("body").find("[data-drawer-title]").html(cartTitleLabel);
            $("body").find("[data-side-drawer]").attr("id", "mini__cart");
            $("body").find("[data-side-drawer]").addClass("mini_cart");
          }

          $("body").removeClass("quickview-open");
          $("body").addClass("side_Drawer_open");
          if (document.getElementById("addToCartAlert")) {
            document.getElementById("addToCartAlert").play();
          }
          if (hapticFeedbackStatus) {
            const canVibrate = window.navigator.vibrate;
            if (canVibrate) window.navigator.vibrate(500);
          }
          jQuery.getJSON(cartUrl, function (cart, textStatus) {
            buildCart(cart, true);
            setTimeout(function () {
              submit.removeClass("is-loading");
            }, 1000);
          });
        },
        error: function (XMLHttpRequest, textStatus) {
          focusElement = "";
          if (typeof errorCallback === "function") {
            errorCallback(XMLHttpRequest, textStatus);
          } else {
            let errorContainer = parentSection.find(".productErrors");
            if (errorContainer.length > 0) {
              if (XMLHttpRequest.responseJSON.errors) {
                let giftCardWrapper = form.find("[data-gift-card-box]");
                if (
                  giftCardWrapper.length > 0 &&
                  XMLHttpRequest.responseJSON.errors["email"]
                ) {
                  let errormessageWrapper = giftCardWrapper.find(
                    "[data-gift-card-errors]"
                  );
                  let giftCardEmail = giftCardWrapper.find("[type=email]");
                  errorContainer
                    .html(
                      giftCardEmail.attr("data-attr") +
                        " " +
                        XMLHttpRequest.responseJSON.errors["email"]
                    )
                    .show();
                }
              } else {
                errorContainer
                  .html(XMLHttpRequest.responseJSON.description)
                  .show();
              }
            }
          }
          setTimeout(function () {
            $(".Sd_addProductSticky").removeClass("is-loading");
            submit.removeClass("is-loading");
          }, 1000);
        },
      };
      jQuery.ajax(params);
    });

    // Update quantity based on input on change

    $(document).on("click", ".quantity-button", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        $qtySelector = $el.closest(".quantity").find(".ajaxcart__qty-num");
      // Block quantity changes on free gift item
      if (parent.attr("data-gift-handle") === freeGiftHandle) {
        return;
      }
      // Block quantity changes on BXGY bonus item
      if (bxgyEnabled && parent.attr("data-bxgy-handle") === bxgyBonusHandle) {
        return;
      }
      var qty = $qtySelector.val();
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      if (qty) {
        qty = parseInt(qty.replace(/\D/g, ""));
      }

      var qty = validateQty(qty);

      // Add or subtract from the current quantity
      if ($el.hasClass("ajaxcart__qty--plus")) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }
      $qtySelector.val(qty);
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    // Update quantity based on input on change
    $(document).on("change", ".ajaxcart__qty-num", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = $el.data("line"),
        qty = parseInt($el.val().replace(/\D/g, ""));

      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      var qty = validateQty(qty);

      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, qty, buildCart);
      }
    });

    function openCartDrawer(element) {
      $("[data-drawer-body]").html(preLoadLoadGif);
      $("body").find("[data-drawer-title]").html(cartTitleLabel);
      $("body")
        .find("[data-side-drawer]")
        .attr("class", "yv_side_drawer_wrapper");
      $("body")
        .find("[data-side-drawer]")
        .attr("id", "mini__cart")
        .addClass("mini_cart");
      $("body").addClass("side_Drawer_open");
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        buildCart(cart, true, element);
      });
    }
    $("body").on("click", ".openCartDrawer", function (e) {
      e.preventDefault();
      openCartDrawer($(this));
    });

    $("body").on("keydown", ".openCartDrawer", function (e) {
      if (e.code.toUpperCase() === "SPACE") {
        e.preventDefault();
        openCartDrawer($(this));
      }
    });

    $(document).on("click", ".sd_mini_removeproduct", function (evt) {
      evt.preventDefault();
      var $el = $(this),
        parent = $el.closest(".media-link"),
        line = parseInt($el.attr("data-line"));
      // Track if customer manually removes the free gift
      if (freeGiftEnabled && parent.attr("data-gift-handle") === freeGiftHandle) {
        sessionStorage.setItem("freeGiftDeclined", "true");
      }
      // Track if customer manually removes the BXGY bonus
      if (bxgyEnabled && parent.attr("data-bxgy-handle") === bxgyBonusHandle) {
        sessionStorage.setItem("bxgyDeclined", "true");
        updateBxgyAttribute("removed_by_customer");
      }
      parent.addClass("disabled");
      parent.closest(".cart-items-wrapper").addClass("disabled");
      // If it has a data-line, update the cart
      if (line) {
        updateQuantity(line, 0, buildCart);
      }
    });

    $(document).on("click ", ".cartDrawerNote", function (evt) {
      $(this).toggleClass("active");
      var textArea = $(this).siblings(".cartNoteContainer");
      textArea.slideToggle();
    });
  }
}

$("body").on("click", "#GiftWrapProduct", function () {
  params = {
    type: "POST",
    url: cartAddUrl,
    data: { id: parseInt($(this).attr("data-product")), quantity: 1 },
    dataType: "json",
    success: function (line_item) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          cartPageUpdate(cart);
        } else {
          buildCart(cart, true);
        }
      });
    },
    error: function (XMLHttpRequest, textStatus) {
      jQuery.getJSON(cartUrl, function (cart, textStatus) {
        if (window.location.pathname.indexOf("/cart") > -1) {
          buildCart(cart, true);
        } else {
          cartPageUpdate(cart);
        }
      });
    },
  };
  jQuery.ajax(params);
});

cartPageUpdate = function (cart) {
  $.ajax({
    url: mainCartUrl,
    type: "GET",
    dataType: "html",
    success: function (result) {
      $("body")
        .find("[data-cart-wrapper]")
        .html($(result).find("[data-cart-wrapper]").html());
      $(".cart-section").find("a:first").trigger("focus");
      freeShippingBar(cart);
      bxgyCheck(cart);
      upsellCartProducts(cart);
      window.shippingEstimates();
      // $('body').find('[data-cart-items]').html($(result).find('[data-cart-items]').html());
      // $("body").find("[data-cart-items]").removeClass('disabled');
      // if (cart.item_count == 0) {
      //     emptyCartStatus = true;
      //     $('[data-cart-count').hide();
      //     $('.cart-section').find('a:first').trigger('focus');
      // } else {
      //     emptyCartStatus = false;
      //     $('body').find('[data-cart-items]').find('a:first').trigger('focus');
      // }
      // $('[data-cart-item-count]').text(cart.item_count);
      // $('[data-cart-original-price]').text(Shopify.formatMoney(cart.original_total_price, moneyFormat));
      // $('[data-cart-total-price]').text(Shopify.formatMoney(cart.total_price, moneyFormat));
      // if (cart.cart_level_discount_applications.length > 0) {
      //     var discounts = '';
      //     $.each(cart.cart_level_discount_applications, function(index, discount) {
      //         discounts += '<li data-cart-discount>Discount[' + discount.title + '] <strong>-' + Shopify.formatMoney(discount.total_allocated_amount, moneyFormat) + '</strong></li>';
      //     })
      //     $('li[data-cart-discount]').remove();
      //     $('li[data-cart-original]').removeClass('hidden');
      //     $(discounts).insertAfter('li[data-cart-original]')
      // } else {
      //     $('li[data-cart-original]').addClass('hidden');
      //     $('li[data-cart-discount]').remove();
      // }
      if (animationStatus) {
        if (AOS) {
          AOS.refreshHard();
        }
      }
    },
  });
};

buildCart = function (cart, showCart, element) {
  if (cart.item_count === 0) {
    emptyCartStatus = true;
    $("[data-cart-count]").hide();
  } else {
    emptyCartStatus = false;
    $("[data-cart-count]").show();
  }
  cartItemsCount = cart.item_count;
  if (cartItemsCount > 0 && cartItemsCount < 100) {
    $("[data-cart-count]").text(cart.item_count);
  } else {
    $("[data-cart-count]").text("");
  }
  if (favicon) {
    favicon.badge(cartItemsCount);
  }
  $("[data-drawer-body]").load(mainCartUrl + "?view=jsonData", function () {
    freeShippingBar(cart);
    bxgyCheck(cart);
    upsellCartDrawerProducts(cart, "drawer");
    crossSellProducts(cart);
    if (showCart) {
      $("body").addClass("yv_side_Drawer_open");
      $(".wrapper-overlay").css({ display: "block" });
      focusElementsRotation($("[data-side-drawer]"));
      if (element) {
        focusElement = element;
      }
      $(document).find(".yv_side_drawer_wrapper").trigger("focus");
      // $('[data-drawer-body]').find('a:first').trigger('focus');
    }
    if (animationStatus) {
      if (AOS) {
        AOS.refreshHard();
      }
    }
  });
};

$(document).on("click", "[data-drawer-side-header]", function () {
  if ($(this).closest(".yv-upsell-drawer").hasClass("active")) {
    $(this).closest(".yv-upsell-drawer").removeClass("active");
  } else {
    $(this).closest(".yv-upsell-drawer").addClass("active");
  }
});

function upsellCartDrawerProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-drawer-side-content]")) {
      let upsellContainer = document.querySelector(
        "[data-drawer-side-content]"
      );
      let intent = upsellContainer.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellContainer.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              upsellContainer.innerHTML = recommendations.innerHTML;
              document
                .querySelector(".yv-upsell-drawer")
                .classList.remove("hidden");
            } else {
              document
                .querySelector(".yv-upsell-drawer")
                .classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.children.length > 0) {
          document
            .querySelector(".yv-upsell-drawer")
            .classList.remove("hidden");
        } else {
          document.querySelector(".yv-upsell-drawer").classList.add("hidden");
        }
      }
    }
  }
}

function upsellCartProducts(cart) {
  if (cart.item_count != 0) {
    if (document.querySelector("[data-cart-upsell-wrapper]")) {
      let upsellWrapper = document.querySelector("[data-cart-upsell-wrapper]");
      let upsellContainer = upsellWrapper.querySelector("[data-cart-upsell]");
      let intent = upsellWrapper.getAttribute("data-related-products");
      if (intent != "product-list") {
        let productId = cart.items[0].product_id;
        let limit = upsellWrapper.getAttribute("data-limit");
        fetch(
          window.Shopify.routes.root +
            "recommendations/products?product_id=" +
            productId +
            "&limit=" +
            limit +
            "&section_id=upsell-products&intent=" +
            intent
        )
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement("div");
            html.innerHTML = text;
            const recommendations = html.querySelector(
              "#product-recommendations"
            );
            if (recommendations && recommendations.innerHTML.trim().length) {
              if (window.innerWidth >= 768) {
                if (upsellContainer.classList.contains("flickity-enabled")) {
                  let slider = Flickity.data(upsellContainer);
                  if (slider) {
                    slider.destroy();
                    upsellContainer.innerHTML = recommendations.innerHTML;
                    upsellWrapper.classList.remove("hidden");
                    flickitySlider(jQuery(upsellContainer));
                  }
                } else {
                  upsellContainer.innerHTML = recommendations.innerHTML;
                  upsellWrapper.classList.remove("hidden");
                  flickitySlider(jQuery(upsellContainer));
                }
              } else {
                upsellContainer.innerHTML = recommendations.innerHTML;
                upsellWrapper.classList.remove("hidden");
              }
            } else {
              upsellWrapper.classList.add("hidden");
            }
          });
      } else {
        if (upsellContainer.classList.contains("flickity-enabled")) {
          let slider = Flickity.data(upsellContainer);
          if (slider) {
            slider.destroy();
          }
        }
        if (upsellContainer.children.length > 0) {
          if (window.innerWidth >= 768) {
            upsellWrapper.classList.remove("hidden");
            flickitySlider(jQuery(upsellContainer));
          } else {
            upsellWrapper.classList.remove("hidden");
          }
        } else {
          upsellWrapper.classList.add("hidden");
        }
      }
    }
  }
}

document.addEventListener('submit', async function (e) {
  const form = e.target;
  if (!form || form.id !== 'DrawerDiscountForm') return;

  e.preventDefault();

  const input = form.querySelector('#DrawerDiscount');
  const msg = document.querySelector('#DrawerDiscountMsg');
  const btn = form.querySelector('button[type="submit"]');
  const code = (input?.value || '').trim();

  const setMsg = (text, type) => {
    if (!msg) return;
    msg.textContent = text || '';
    msg.dataset.type = type || '';
  };

  if (!code) {
    setMsg('Please enter a code.', 'error');
    return;
  }

  setMsg('Applying…', 'loading');
  if (btn) btn.disabled = true;

  try {
    // 1) Try applying discount code (gift cards won’t apply here — that’s OK)
    await fetch(`/discount/${encodeURIComponent(code)}`, {
      method: 'GET',
      credentials: 'include',
      redirect: 'follow'
    });

    // 2) Refresh just the drawer using your theme’s existing mechanism
    jQuery.getJSON(cartUrl, function (cart) {
      // rebuild drawer contents (no full page refresh)
      buildCart(cart, true);

      // 3) Lightweight “did it work?” check:
      // If your drawer shows discount rows inside .list-unstyled, we can detect it.
      // (This is a best-effort check—Shopify doesn’t give a simple “invalid code” response here.)
      setTimeout(() => {
        const discountText = document.querySelector('.bottom-cart-box .list-unstyled')?.innerText?.toLowerCase() || '';
        const applied = discountText.includes(code.toLowerCase());

        if (applied) {
          setMsg('Applied.', 'success');
          if (input) input.value = '';
        } else {
          setMsg("Code isn’t available right now. If this is a gift card, apply it at checkout.", 'error');
        }

        if (btn) btn.disabled = false;
      }, 600);
    });

  } catch (err) {
    setMsg('Sorry — could not apply that code. Please try again.', 'error');
    if (btn) btn.disabled = false;
  }
});
/*
 * BUNDLE RULES — Priority 1 (highest)
 * Each rule: requires = array of handles OR { type: "..." } for type matching
 * Optional "upgrade" array: if cart ALSO has these, switch to upgradeSuggest instead
 * Rules are checked longest-match-first automatically.
 */
var crossSellBundleRules = [
  /* 3-product upgrades (checked first due to longer match) */
  { requires: ['super-fruit-hydrator', 'super-citrus-cleanser', 'serum-of-clear'], suggest: 'clear-skin' },
  { requires: ['super-fruit-hydrator', 'super-citrus-cleanser', 'glory-oil'], suggest: 'clear-skin' },

  /* 2-product rules with optional upgrade */
  { requires: ['super-fruit-hydrator', 'super-citrus-cleanser'], suggest: 'intro-kit',
    upgrade: [
      { ifAlso: ['serum-of-clear'], suggest: 'clear-skin' },
      { ifAlso: ['glory-oil'], suggest: 'clear-skin' }
    ]
  },
  { requires: ['serum-of-plenty', 'super-fruit-hydrator'], suggest: 'hydration-skin-system' },
  { requires: ['serum-of-plenty', 'glory-cream'], suggest: 'menopause-system' },
  { requires: ['serum-of-plenty', 'serum-of-clear'], suggest: 'pigmentation-melasma-system' },
  { requires: ['serum-of-clear', 'super-fruit-hydrator'], suggest: 'clear-skin' },

  /* Type-based rule: face-tan-water + a DIFFERENT "tanning" type product */
  { requires: ['face-tan-water', { type: 'tanning', excludeHandle: 'face-tan-water' }], suggest: 'tanning-kit' },

  /* Same-handle quantity rule: 2x glory-gloss → trio */
  { requires: ['glory-gloss', 'glory-gloss'], suggest: 'glory-gloss-trio' }
];

/* Sort rules by requires length descending (longest match wins) */
crossSellBundleRules.sort(function (a, b) { return b.requires.length - a.requires.length; });

/*
 * TANNING SUGGESTION RULES
 * Specific product suggestions when tanning products are in cart.
 */
var crossSellTanningRules = [
  { trigger: { handle: 'face-tan-water' }, suggest: ['super-fruit-hydrator', 'super-acai-exfoliator', 'super-citrus-cleanser'] },
  { trigger: { type: 'tanning', excludeHandle: 'face-tan-water' }, suggest: ['body-milk', 'pink-himalayan-salt-scrub', 'exfoliating-glove'] }
];

/*
 * GAP FILLER PRODUCTS
 * Affordable products fetched when there's a shipping gap, to ensure
 * the scoring has cheap options to recommend.
 */
var crossSellGapFillers = ['glory-lips', 'lip-liner', 'cream-blush'];

/**
 * Check if a bundle rule matches the current cart.
 * Returns the suggested handle or null.
 */
function matchBundleRule(rule, cartHandles, cartTypes, cartHandleCounts, cartItems) {
  var tempCounts = {};
  for (var i = 0; i < rule.requires.length; i++) {
    var req = rule.requires[i];
    if (typeof req === 'object' && req.type) {
      var typeMatch = false;
      if (req.excludeHandle) {
        for (var ci = 0; ci < cartItems.length; ci++) {
          var item = cartItems[ci];
          if (item.product_type && item.product_type.toLowerCase() === req.type.toLowerCase() && item.handle !== req.excludeHandle) {
            typeMatch = true;
            break;
          }
        }
      } else {
        for (var t = 0; t < cartTypes.length; t++) {
          if (cartTypes[t].toLowerCase() === req.type.toLowerCase()) { typeMatch = true; break; }
        }
      }
      if (!typeMatch) return null;
    } else {
      var needed = (tempCounts[req] || 0) + 1;
      tempCounts[req] = needed;
      if ((cartHandleCounts[req] || 0) < needed) return null;
    }
  }

  if (rule.upgrade) {
    for (var u = 0; u < rule.upgrade.length; u++) {
      var up = rule.upgrade[u];
      var upgradeMatch = true;
      for (var j = 0; j < up.ifAlso.length; j++) {
        if (cartHandles.indexOf(up.ifAlso[j]) === -1) { upgradeMatch = false; break; }
      }
      if (upgradeMatch) return up.suggest;
    }
  }

  return rule.suggest;
}

function crossSellProducts(cart) {
  var CS_DEBUG = false;
  var log = function () { if (CS_DEBUG) console.log.apply(console, ['[CrossSell]'].concat(Array.prototype.slice.call(arguments))); };
  var warn = function () { if (CS_DEBUG) console.warn.apply(console, ['[CrossSell]'].concat(Array.prototype.slice.call(arguments))); };

  var container = document.querySelector('[data-cross-sell-list]');
  var wrapper = document.querySelector('[data-cart-cross-sell]');
  var heading = wrapper ? wrapper.querySelector('[data-cross-sell-heading]') : null;
  if (!container || !wrapper) { warn('Missing container or wrapper element'); return; }
  if (!cart.items || cart.items.length === 0) {
    wrapper.style.display = 'none';
    return;
  }

  var cartProductIds = [];
  var cartHandles = [];
  var cartHandleCounts = {};
  var cartTypes = [];
  var cartPrice = 0;

  cart.items.forEach(function (item) {
    if (item.product_type && item.product_type.toLowerCase() === 'gift card') return;
    if (cartProductIds.indexOf(item.product_id) === -1) {
      cartProductIds.push(item.product_id);
    }
    if (item.handle) {
      if (cartHandles.indexOf(item.handle) === -1) cartHandles.push(item.handle);
      cartHandleCounts[item.handle] = (cartHandleCounts[item.handle] || 0) + item.quantity;
    }
    if (item.product_type && cartTypes.indexOf(item.product_type) === -1) {
      cartTypes.push(item.product_type);
    }
    cartPrice += item.line_price;
  });

  log('Cart handles:', cartHandles);
  log('Cart handle counts:', JSON.parse(JSON.stringify(cartHandleCounts)));
  log('Cart types:', cartTypes);
  log('Cart price (cents):', cartPrice);

  if (cartProductIds.length === 0) {
    wrapper.style.display = 'none';
    return;
  }

  var bundleSuggestHandle = null;
  for (var r = 0; r < crossSellBundleRules.length; r++) {
    var rule = crossSellBundleRules[r];
    var match = matchBundleRule(rule, cartHandles, cartTypes, cartHandleCounts, cart.items);
    if (match) {
      log('Rule MATCHED:', JSON.stringify(rule.requires), '→', match);
      if (cartHandles.indexOf(match) === -1) {
        bundleSuggestHandle = match;
      } else {
        log('But pack "' + match + '" is already in cart — skipping');
      }
      break;
    } else {
      log('Rule checked (no match):', JSON.stringify(rule.requires));
    }
  }

  if (bundleSuggestHandle) {
    log('Bundle suggestion:', bundleSuggestHandle);
  } else {
    log('No bundle rule matched');
  }

  var shippingThreshold = (typeof convertShippingAmount !== 'undefined') ? convertShippingAmount : 0;
  var shippingGap = shippingThreshold > 0 ? shippingThreshold - cartPrice : 0;
  var needsShippingHelp = shippingGap > 0;
  var smallGap = shippingGap > 0 && shippingGap <= 3000;

  log('Shipping threshold (cents):', shippingThreshold, '| Gap:', shippingGap, '| Small gap:', smallGap);

  var tanningSuggestHandles = [];
  for (var tr = 0; tr < crossSellTanningRules.length; tr++) {
    var tRule = crossSellTanningRules[tr];
    var triggered = false;
    if (tRule.trigger.handle && cartHandles.indexOf(tRule.trigger.handle) !== -1) {
      triggered = true;
    } else if (tRule.trigger.type) {
      for (var tt = 0; tt < cartTypes.length; tt++) {
        if (cartTypes[tt].toLowerCase() === tRule.trigger.type.toLowerCase()) {
          if (tRule.trigger.excludeHandle) {
            for (var ci = 0; ci < cart.items.length; ci++) {
              if (cart.items[ci].product_type && cart.items[ci].product_type.toLowerCase() === tRule.trigger.type.toLowerCase() && cart.items[ci].handle !== tRule.trigger.excludeHandle) {
                triggered = true;
                break;
              }
            }
          } else {
            triggered = true;
          }
          break;
        }
      }
    }
    if (triggered) {
      tanningSuggestHandles = tRule.suggest.filter(function (h) { return cartHandles.indexOf(h) === -1; });
      log('Tanning rule matched:', JSON.stringify(tRule.trigger), '→', tanningSuggestHandles);
      break;
    }
  }

  var gapFillerHandles = needsShippingHelp
    ? crossSellGapFillers.filter(function (h) { return cartHandles.indexOf(h) === -1; })
    : [];
  if (gapFillerHandles.length) log('Gap filler candidates:', gapFillerHandles);

  var bundleFetchUrl = bundleSuggestHandle
    ? window.Shopify.routes.root + 'products/' + bundleSuggestHandle + '.js'
    : null;

  if (bundleFetchUrl) log('Fetching bundle product:', bundleFetchUrl);

  var bundleFetch = bundleSuggestHandle
    ? fetch(bundleFetchUrl)
        .then(function (r) {
          if (!r.ok) { warn('Bundle fetch FAILED — HTTP ' + r.status + ' for ' + bundleFetchUrl); return null; }
          return r.json();
        })
        .then(function (product) {
          if (!product) return null;
          if (!product.available) { warn('Bundle product "' + bundleSuggestHandle + '" exists but is UNAVAILABLE'); return null; }
          log('Bundle product fetched OK:', product.title, '— $' + (product.price / 100).toFixed(2));
          return {
            id: String(product.id),
            variantId: String(product.variants[0].id),
            handle: product.handle,
            title: product.title,
            price: '£' + (product.price / 100).toFixed(2),
            priceCents: product.price,
            productType: product.type || '',
            url: window.Shopify.routes.root + 'products/' + product.handle,
            image: product.featured_image ? product.featured_image : '',
            isBundle: true
          };
        })
        .catch(function (err) { warn('Bundle fetch ERROR:', err); return null; })
    : Promise.resolve(null);

  var allRecs = [];
  var seenIds = {};
  var limit = 6;
  var recFetches = cartProductIds.map(function (pid) {
    return fetch(
      window.Shopify.routes.root +
        'recommendations/products?product_id=' + pid +
        '&limit=' + limit +
        '&section_id=cross-sell-products&intent=complementary'
    )
      .then(function (r) { return r.text(); })
      .then(function (text) {
        var tmp = document.createElement('div');
        tmp.innerHTML = text;
        var items = tmp.querySelectorAll('.cross-sell-data');
        items.forEach(function (el) {
          var id = el.getAttribute('data-product-id');
          if (seenIds[id] || cartProductIds.indexOf(parseInt(id)) !== -1) return;
          if (el.getAttribute('data-available') === 'false') return;
          seenIds[id] = true;
          allRecs.push({
            id: id,
            variantId: el.getAttribute('data-variant-id'),
            handle: el.getAttribute('data-handle'),
            title: el.getAttribute('data-title'),
            price: el.getAttribute('data-price'),
            priceCents: parseInt(el.getAttribute('data-price-cents')) || 0,
            productType: el.getAttribute('data-product-type') || '',
            url: el.getAttribute('data-url'),
            image: el.getAttribute('data-image'),
            isBundle: false
          });
        });
      })
      .catch(function () {});
  });

  function fetchProductHandle(handle) {
    return fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
      .then(function (r) { if (!r.ok) return null; return r.json(); })
      .then(function (product) {
        if (!product || !product.available) return null;
        return {
          id: String(product.id),
          variantId: String(product.variants[0].id),
          handle: product.handle,
          title: product.title,
          price: '£' + (product.price / 100).toFixed(2),
          priceCents: product.price,
          productType: product.type || '',
          url: window.Shopify.routes.root + 'products/' + product.handle,
          image: product.featured_image ? product.featured_image : '',
          isBundle: false
        };
      })
      .catch(function () { return null; });
  }

  var gapFillerFetches = gapFillerHandles.map(fetchProductHandle);
  var tanningFetches = tanningSuggestHandles.map(fetchProductHandle);

  Promise.all([bundleFetch, Promise.all(recFetches), Promise.all(gapFillerFetches), Promise.all(tanningFetches)]).then(function (results) {
    var bundleProduct = results[0];
    var gapFillerProducts = results[2].filter(function (p) { return p !== null; });
    var tanningProducts = results[3].filter(function (p) { return p !== null; });

    log('Gap fillers fetched:', gapFillerProducts.map(function (p) { return p.title + ' ($' + (p.priceCents / 100).toFixed(2) + ')'; }));
    if (tanningProducts.length) log('Tanning products fetched:', tanningProducts.map(function (p) { return p.title; }));

    gapFillerProducts.forEach(function (gf) {
      if (!seenIds[gf.id] && cartProductIds.indexOf(parseInt(gf.id)) === -1) {
        seenIds[gf.id] = true;
        allRecs.push(gf);
      }
    });

    allRecs.forEach(function (rec) {
      var score = 1;
      if (needsShippingHelp && rec.priceCents > 0 && rec.priceCents >= shippingGap) {
        var overshoot = rec.priceCents - shippingGap;
        if (overshoot <= 1500) score += 12;
        else if (overshoot <= 3000) score += 8;
        else score += 5;
      }
      if (rec.productType) {
        for (var t = 0; t < cartTypes.length; t++) {
          if (cartTypes[t].toLowerCase() === rec.productType.toLowerCase()) {
            score += 5;
            break;
          }
        }
      }
      rec.score = score;
    });

    allRecs.sort(function (a, b) { return b.score - a.score; });

    log('Scored recommendations:', allRecs.map(function (r) { return r.title + ' (score:' + r.score + ', $' + (r.priceCents / 100).toFixed(2) + ', type:' + r.productType + ')'; }));

    var finalList = [];
    var finalIds = {};
    var hasBundleInList = false;

    function addToFinal(product, label) {
      if (finalList.length >= 3) return false;
      if (finalIds[product.id]) return false;
      if (cartProductIds.indexOf(parseInt(product.id)) !== -1) return false;
      finalIds[product.id] = true;
      finalList.push(product);
      log('Slot ' + finalList.length + ': ' + label + ' →', product.title, product.score ? '(score:' + product.score + ')' : '');
      return true;
    }

    if (smallGap) {
      var qualifiedFillers = allRecs.filter(function (r) { return r.priceCents >= shippingGap; });
      qualifiedFillers.sort(function (a, b) { return a.priceCents - b.priceCents; });
      if (qualifiedFillers.length > 0) {
        addToFinal(qualifiedFillers[0], 'GAP FILLER');
      }
      log('Small gap — gap filler prioritised');
    }

    if (bundleProduct) {
      if (cartHandles.indexOf(bundleProduct.handle) === -1) {
        if (addToFinal(bundleProduct, 'BUNDLE')) {
          hasBundleInList = true;
        }
      } else {
        log('Bundle "' + bundleProduct.handle + '" already in cart — not showing');
      }
    }

    for (var tp = 0; tp < tanningProducts.length && finalList.length < 3; tp++) {
      addToFinal(tanningProducts[tp], 'TANNING');
    }

    for (var i = 0; i < allRecs.length && finalList.length < 3; i++) {
      addToFinal(allRecs[i], 'REC');
    }

    if (finalList.length === 0) {
      wrapper.style.display = 'none';
      log('No products to show — hiding section');
      return;
    }

    if (heading) {
      heading.textContent = (hasBundleInList && !smallGap) ? 'Complete the ritual' : 'You will also love';
    }

    var html = '';
    finalList.forEach(function (p) {
      var imgSrc = p.image;
      if (p.isBundle && imgSrc && imgSrc.indexOf('http') !== 0) {
        imgSrc = 'https:' + imgSrc;
      }
      html += '<div class="cart-cross-sell__card' + (p.isBundle ? ' cart-cross-sell__card--bundle' : '') + '">' +
        '<a href="' + p.url + '" class="cart-cross-sell__img" data-cs-qv-handle="' + p.handle + '" data-cs-qv-source="' + (p.isBundle ? 'bundle' : 'recommendation') + '">' +
          (imgSrc
            ? '<img src="' + imgSrc + '" alt="' + p.title + '" loading="lazy">'
            : '<span class="cart-cross-sell__placeholder"></span>') +
        '</a>' +
        '<div class="cart-cross-sell__info">' +
          '<a href="' + p.url + '" class="cart-cross-sell__title" data-cs-qv-handle="' + p.handle + '">' + p.title + '</a>' +
          '<span class="cart-cross-sell__price">' + p.price + '</span>' +
        '</div>' +
        '<button type="button" class="cart-cross-sell__add" data-cross-sell-add="' + p.variantId + '" data-cross-sell-source="' + (p.isBundle ? 'bundle' : 'recommendation') + '" aria-label="Add ' + p.title + ' to cart">+</button>' +
      '</div>';
    });

    container.innerHTML = html;
    wrapper.style.display = '';
    log('Rendered', finalList.length, 'cross-sell products');
  });
}

/* ── Cross-sell Quick View ── */
function openCrossSellQuickView(handle, source) {
  var overlay = document.querySelector('[data-cs-qv]');
  var body = document.querySelector('[data-cs-qv-body]');
  if (!overlay || !body) return;
  overlay.setAttribute('data-cs-qv-active-source', source || 'recommendation');

  body.innerHTML = '<div class="cs-qv-loading">Loading...</div>';
  overlay.style.display = '';
  document.body.classList.add('cs-qv-open');

  fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
    .then(function (r) { return r.json(); })
    .then(function (product) {
      var image = product.featured_image ? product.featured_image : (product.images && product.images.length ? product.images[0] : '');
      var firstAvailable = null;
      var hasVariants = product.variants.length > 1;

      for (var v = 0; v < product.variants.length; v++) {
        if (product.variants[v].available) { firstAvailable = product.variants[v]; break; }
      }
      if (!firstAvailable) firstAvailable = product.variants[0];

      var html = '<div class="cs-qv-product">';

      if (image) {
        html += '<div class="cs-qv-image"><img src="' + image + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '"></div>';
      }

      html += '<div class="cs-qv-details">';
      html += '<h3 class="cs-qv-title">' + product.title + '</h3>';
      html += '<p class="cs-qv-price" data-cs-qv-price>£' + (firstAvailable.price / 100).toFixed(2) + '</p>';

      if (product.description) {
        html += '<div class="cs-qv-desc">' + product.description + '</div>';
      }

      if (hasVariants) {
        html += '<div class="cs-qv-variants">';
        html += '<label class="cs-qv-variants__label">Option</label>';
        html += '<select class="cs-qv-variants__select" data-cs-qv-variant>';
        for (var i = 0; i < product.variants.length; i++) {
          var v = product.variants[i];
          var vImg = (v.featured_image && v.featured_image.src) ? v.featured_image.src : '';
          html += '<option value="' + v.id + '" data-price="' + v.price + '" data-image="' + vImg + '"' +
            (!v.available ? ' disabled' : '') +
            (v.id === firstAvailable.id ? ' selected' : '') +
            '>' + v.title + (!v.available ? ' — Sold out' : '') + '</option>';
        }
        html += '</select>';
        html += '</div>';
      }

      html += '<button type="button" class="cs-qv-atc" data-cs-qv-atc="' + firstAvailable.id + '"' +
        (!firstAvailable.available ? ' disabled' : '') + '>' +
        (firstAvailable.available ? 'Add to cart' : 'Sold out') + '</button>';

      html += '<a href="' + window.Shopify.routes.root + 'products/' + product.handle + '" class="cs-qv-link">View full details</a>';

      html += '</div></div>';
      body.innerHTML = html;

      var select = body.querySelector('[data-cs-qv-variant]');
      if (select) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          var atcBtn = body.querySelector('[data-cs-qv-atc]');
          var priceEl = body.querySelector('[data-cs-qv-price]');
          var imgEl = body.querySelector('.cs-qv-image img');
          atcBtn.setAttribute('data-cs-qv-atc', opt.value);
          atcBtn.disabled = opt.disabled;
          atcBtn.textContent = opt.disabled ? 'Sold out' : 'Add to cart';
          if (priceEl) priceEl.textContent = '£' + (parseInt(opt.getAttribute('data-price')) / 100).toFixed(2);
          var vImg = opt.getAttribute('data-image');
          if (vImg && imgEl) imgEl.src = vImg;
        });
      }
    })
    .catch(function () {
      body.innerHTML = '<p style="padding:20px;text-align:center;">Could not load product.</p>';
    });
}

function closeCrossSellQuickView() {
  var overlay = document.querySelector('[data-cs-qv]');
  if (overlay) overlay.style.display = 'none';
  document.body.classList.remove('cs-qv-open');
}

document.addEventListener('click', function (e) {
  var trigger = e.target.closest('[data-cs-qv-handle]');
  if (!trigger) return;
  e.preventDefault();
  var source = trigger.getAttribute('data-cs-qv-source') || 'recommendation';
  openCrossSellQuickView(trigger.getAttribute('data-cs-qv-handle'), source);
});

document.addEventListener('click', function (e) {
  if (e.target.closest('[data-cs-qv-close]')) { closeCrossSellQuickView(); return; }
  if (e.target.matches('[data-cs-qv]')) { closeCrossSellQuickView(); }
});

document.addEventListener('keydown', function (e) {
  if (e.key === 'Escape') closeCrossSellQuickView();
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cs-qv-atc]');
  if (!btn) return;
  var variantId = btn.getAttribute('data-cs-qv-atc');
  if (!variantId) return;

  var overlay = document.querySelector('[data-cs-qv]');
  var source = (overlay && overlay.getAttribute('data-cs-qv-active-source')) || 'recommendation';

  btn.disabled = true;
  btn.textContent = 'Adding...';

  jQuery.ajax({
    type: 'POST',
    url: cartAddUrl,
    data: {
      id: variantId,
      quantity: 1,
      properties: {
        _cross_sell: 'true',
        _cross_sell_source: source,
        _cross_sell_location: 'cart_drawer_quickview'
      }
    },
    dataType: 'json',
    success: function () {
      btn.textContent = 'Added!';
      setTimeout(function () {
        closeCrossSellQuickView();
        jQuery.getJSON(cartUrl, function (cart) {
          buildCart(cart, true);
        });
      }, 600);
    },
    error: function () {
      btn.disabled = false;
      btn.textContent = 'Add to cart';
    }
  });
});

document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-cross-sell-add]');
  if (!btn) return;
  var variantId = btn.getAttribute('data-cross-sell-add');
  if (!variantId) return;
  var source = btn.getAttribute('data-cross-sell-source') || 'recommendation';

  btn.classList.add('is-loading');
  btn.disabled = true;

  jQuery.ajax({
    type: 'POST',
    url: cartAddUrl,
    data: {
      id: variantId,
      quantity: 1,
      properties: {
        _cross_sell: 'true',
        _cross_sell_source: source,
        _cross_sell_location: 'cart_drawer'
      }
    },
    dataType: 'json',
    success: function () {
      jQuery.getJSON(cartUrl, function (cart) {
        buildCart(cart, true);
      });
    },
    error: function () {
      btn.classList.remove('is-loading');
      btn.disabled = false;
    }
  });
});

/* Discount code toggle (collapsible) */
document.addEventListener("click", function (e) {
  var toggle = e.target.closest("[data-discount-toggle]");
  if (!toggle) return;
  var body = toggle.parentElement.querySelector("[data-discount-body]");
  if (!body) return;
  var isOpen = body.style.display !== "none";
  body.style.display = isOpen ? "none" : "block";
  toggle.classList.toggle("active", !isOpen);
});
